import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import ReactPlayer from 'react-player'


function YoutubeModal({ demoVideo, demoVideoShow, setDemoVideoShow, description,title="demoVideo",waiver="",playing=true,loop=true}) {
    if (demoVideo?.length > 0) {
        if (demoVideo.includes("/shorts/")) {
            let standardizedUrl = "https://www.youtube.com/embed/"
            let urlEmbedId = demoVideo.split("/shorts/")[1].split('?')[0];
            standardizedUrl = standardizedUrl + urlEmbedId;
            demoVideo = standardizedUrl
        }
        if (!ReactPlayer.canPlay(demoVideo) && demoVideoShow) {
            let linkStart = demoVideo?.split('://')[0];
            if (linkStart != "https" && linkStart != "http") {
                demoVideo = "https://" + demoVideo;
            }
            window.open(demoVideo)
            setDemoVideoShow(false);
        }
    }

    const [showWaiver,setShowWaiver] = useState(false)

    return (
        <Modal 
            show={demoVideoShow} 
            onHide={() => setDemoVideoShow(false)}
        >
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center flex-column">
                <ReactPlayer
                    url={demoVideo}
                    controls={true}
                    loop={loop}
                    playing={playing}
                    width="100%"
                />
                <div className="mt-1">{description}</div>
                {Boolean(waiver)&&
                    <div>
                        <small>
                            <i className="fas fa-exclamation-circle mr-1"></i> By watching this video, you acknowledge that you have read and agree to the terms of the 
                            <button 
                                className="mx-1 my-0 text-primary" 
                                onClick={setShowWaiver.bind(null,p=>!p)} 
                                size="sm" 
                                variant="link"
                                style={{
                                    border:'none',
                                    background:'none',
                                    padding:0
                                }}
                            >
                                video waiver
                            </button>
                        </small>
                        {showWaiver&&
                            <>
                                <hr className="my-1"/>
                                <small>
                                    <strong className="d-block">Video Waiver</strong>
                                    {waiver}
                                </small>
                            </>
                        }
                    </div>
                }
            </Modal.Body>
        </Modal>
    )
}

export default YoutubeModal